import NavTabs from "./NavTabs";

export default NavTabs;